import { Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';

@Component({
  selector: '[stages]',
  imports: [ContainerComponent],
  templateUrl: './stages.component.html',
  styleUrl: './stages.component.scss',
  host: {
    id: 'what-are-the-stages-of-type-1',
  },
})
export class StagesComponent {
  cards = [
    {
      color: 'aqua',
      number: 1,
      topTitle: 'Early-stage type 1 diabetes',
      title: 'Early-stage type 1 diabetes',
      list: [
        'Beta cell attack begins',
        'Blood sugars are within a normal range',
        `<strong>No visible signs or symptoms</strong>`,
        `<strong>Insulin is not needed</strong>`,
        `<strong>Presence of 2 or more T1D autoantibodies</strong>`,
      ],
    },
    {
      color: 'purple',
      number: 2,
      topTitle: 'Early-stage type 1 diabetes',
      title: 'Early-stage type 1 diabetes',
      list: [
        'Beta cell attack continues',
        'Blood sugars are abnormal',
        `<strong>Still no visible signs or symptoms</strong>`,
        `<strong>Daily insulin is not needed</strong>`,
        `<strong>2 or more T1D autoantibodies are present</strong>`,
      ],
    },
    {
      color: 'orange',
      number: 3,
      topTitle: 'Insulin-dependent type 1 diabetes',
      title: 'Insulin-dependent type 1 diabetes',
      list: [
        'A significant number of beta cells have been damaged',
        'High blood sugar (hyperglycemia)',
        `Body no longer able to make enough insulin to control blood sugar levels`,
        `1 or more T1D autoantibodies may be present`,
        `<strong>Visible signs and symptoms appear, and daily insulin dependence begins</strong>`,
      ],
      footnote: '*This stage is when type 1 diabetes is typically diagnosed',
    },
    {
      color: 'yellow',
      number: 4,
      topTitle: 'Long-standing type 1 diabetes',
      title: 'Insulin-dependent type 1 diabetes',
      list: [
        'Few-to-no beta cells remaining',
        'Long term T1D',
        'Dependence on external insulin to control blood sugar',
        'Health complications common',
        'T1D-related autoantibodies may no longer be present',
        `<strong>Daily insulin is still needed</strong>`,
      ],
    },
  ];
}
